import { Component, OnInit, ViewChild, Input } from '@angular/core';
import { DataTable, DataTableResource } from 'angular-4-data-table-bootstrap-4';

import { UscImpressionComponent } from '../usc-impression/usc-impression.component';
import { UscModalComponent } from '../usc-modal/usc-modal.component';

@Component({
  selector: 'sn-usc-first',
  templateUrl: '../usc-impression/usc-impression.component.html',
  styleUrls: ['../usc-store.component.css', './usc-first.component.css']
})
export class UscFirstComponent extends UscImpressionComponent {
  
  public orderBy:string = "cfd_pri";
  view:string = this.uscStoreService.view_first;
  public view_connected_call:string = this.uscStoreService.form_connected_call;
  public view_interested:string = this.uscStoreService.form_interested;
  public view_not_interested:string = this.uscStoreService.form_not_interested;
  public view_call_back:string = this.uscStoreService.form_call_back;

  ngOnInit(): void {
    super.ngOnInit();
  }

  showOutcomeLog(item, outcome) {
    if (!this.uscStoreService.isUSCellRetail() && (outcome == this.view_purchase || outcome == this.view_future_sales)) {
      const modalRef = this.ngbModal.open(UscModalComponent, { backdrop: 'static', keyboard: false });
      modalRef.componentInstance.view = outcome;
      modalRef.componentInstance.data = item;
      modalRef.result.then((result) => {
        if (outcome == this.view_purchase) {
          this.showOutcomeLog(item, this.uscStoreService.form_future_sale);
        } else if (outcome == this.view_future_sales) {
          this.showPromptDlg(item, this.transition_new_referral);
        } else {
          this.pageItemsChecked = false;
          this.uscStoreService.setViewItemUpdated(item);
          this.reloadItems();
          }
      }, (reason) => {
        if (outcome == this.uscStoreService.form_future_sale) {
          this.showPromptDlg(item, this.transition_new_referral);
        }
      });
    } else {
      super.showOutcomeLog(item, outcome);
    }
  }
}


// WEBPACK FOOTER //
// C:/Azure/Source/Workspaces/SalesNOW/SalesSOLO/WebSites/SalesSOLO.Web.Angular.telesales/src/app/components/usc-store/usc-first/usc-first.component.ts